<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-kaia-logo="false"
    :show-lang-picker="false"
    theme="blue-background"
  >
    <div class="kds-main-wrapper renewal-check-in">
      <div class="kds-content-block">
        <p class="kds-typography-title-xlarge kds-typography-center">
          {{ $t('eu__renewal_assessment__check_in__header') }}
        </p>
        <p class="kds-typography-paragraph-large kds-typography-center">
          {{ $t('eu__renewal_assessment__check_in__description') }}
        </p>
        <p class="renewal-check-in__duration kds-typography-paragraph-large">
          <ClockIcon class="renewal-check-in__duration-icon" />
          {{ $t('eu__renewal_assessment__check_in__duration') }}
        </p>
      </div>

      <div class="renewal-check-in__illustration">
        <img
          :src="checkInImage"
          alt=""
          width="335"
          height="280"
        />
      </div>
    </div>

    <template #actions>
      <BaseButton
        :text="$t('generic_action_continue')"
        data-qa="submit"
        @click="handleNextEvent"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import ClockIcon from '@shared/assets/icon/ClockIcon.vue'
import checkInImage from '@shared/assets/img/insurance_covered_private.svg'

// No back button: this screen is the renewal flow's entry point, so there is no
// previous screen to return to.
defineProps({
  progress: { type: Number, default: null },
  handleNextEvent: { type: Function, default: () => {} },
})
</script>

<style scoped lang="scss">
.renewal-check-in {
  &__duration {
    display: flex;
    gap: $kds-space-1x;
    align-items: center;
    justify-content: center;
    color: $kds-color-text-primary;
  }

  &__duration-icon {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
  }

  &__illustration {
    // same treatment the reflection screens give their illustration
    border: 1px solid $kds-color-background-blue-accent;
    border-radius: $kds-space-1x;
    overflow: hidden;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
